class TooltipFormat {
    style: string;
    currency: string;
    currencyDisplay: string;
    precision: number;
    currencySign: string;

    constructor(data: any) {
        this.style = data.style;
        this.currency = data.currency;
        this.currencyDisplay = data.currencyDisplay;
        this.precision = data.precision;
        this.currencySign = data.currencySign;
    }
}